// @flow

import SidebarNav from 'esm-web-pro/components/layout/SidebarNav';
import * as React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getUser } from 'speed-js-react';
import { getIsLandingTab } from 'esm-web-pro/redux/landingTab/selectors';
import Header from './Header';

const SidebarBox = styled(Box)`
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  z-index: 2;
`;

const HeaderBox = styled(Box)`
  position: fixed;
  top: 0;
  left: 0px;
  right: 0;
  z-index: 1;
`;

const Default = ({ children }: { children: React.Node | Array<React.Node> }) => {
    const user = useSelector(getUser);

    return (
        <Box alignContent="center" direction="row" overflow="hidden" height="100%">
            <SidebarBox height="100%" width="60px">
                <SidebarNav />
            </SidebarBox>
            {user && (
                <HeaderBox background={{ color: 'white' }}>
                    <Header />
                </HeaderBox>
            )}
            <Box width="100%" pad={{ left: '60px', top: user ? '60px' : '0px' }}>
                {children}
            </Box>
        </Box>
    );
};

export default Default;
